import { Box, Collapse, Icon, styled, Stack, BasketAmountField, Divider, ArticleNumber } from "@tm/components"
import { Article } from "@tm/models"
import { Typography } from "@mui/material"
import { useUser } from "@tm/context-distribution"
import { getBundleParams } from "@bundles/wheels/utils"
import { ErpWrapper } from "./erpWrapper"

const Container = styled(Box)({
    boxShadow: "0 1px 5px rgb(0 0 0 / 20%)",
    padding: "5px 5px 5px 20px",
    marginLeft: 16,
})

type Props = {
    accessoryKitArticle: Article
    onChangeAccessoryKitArticleQuantity: (amountItem: number) => void
}
export function AccessoryKitArticle({ accessoryKitArticle, onChangeAccessoryKitArticleQuantity }: Props) {
    const userContext = useUser()?.userContext

    const handleQuantityChange = (amountItem: number) => {
        onChangeAccessoryKitArticleQuantity(amountItem)
    }

    const renderThumbnail = () => {
        return <Icon name="article" size="medium" color="primary" sx={{ margin: ".3em" }} />
    }

    const renderErpInformationAndQuantity = () => {
        return (
            <Stack alignItems="center" flexDirection="row" marginRight="4em">
                <ErpWrapper {...accessoryKitArticle} />
                <Box sx={{ minWidth: "6em", marginLeft: "1em" }}>
                    <BasketAmountField
                        originalQuantity={accessoryKitArticle.quantity ?? 1}
                        division={1}
                        onChangeQuantity={(amountItem, loadErpInfo) => handleQuantityChange(amountItem)}
                        loadErpInfos
                    />
                </Box>
            </Stack>
        )
    }

    const renderNumbers = () => {
        if (getBundleParams()?.reverseNumbersOrder) {
            return (
                <>
                    {accessoryKitArticle.supplierArticleNo && (
                        <>
                            <ArticleNumber articleNumber={accessoryKitArticle.supplierArticleNo} articleNumberType="supplier" omitDefaultStyles />
                            <Divider orientation="vertical" flexItem />
                        </>
                    )}
                    <Stack direction="row" alignItems="center" gap={3}>
                        {accessoryKitArticle.traderArticleNo && !userContext?.parameter.hideDealerPartNumber && (
                            <Typography>{accessoryKitArticle.traderArticleNo}</Typography>
                        )}
                        <Typography>{accessoryKitArticle.description}</Typography>
                    </Stack>
                </>
            )
        }

        return (
            <>
                {accessoryKitArticle.traderArticleNo && !userContext?.parameter.hideDealerPartNumber && (
                    <>
                        <ArticleNumber articleNumber={accessoryKitArticle.traderArticleNo} articleNumberType="wholesaler" omitDefaultStyles={false} />
                        <Divider orientation="vertical" flexItem />
                    </>
                )}

                <Stack direction="row" alignItems="center" gap={3}>
                    {accessoryKitArticle.supplierArticleNo && <Typography>{accessoryKitArticle.supplierArticleNo}</Typography>}
                    <Typography>{accessoryKitArticle.description}</Typography>
                </Stack>
            </>
        )
    }

    return (
        <Collapse in>
            <Container>
                <Stack direction="row" justifyContent="space-between">
                    <Stack direction="row" alignItems="center" gap={1}>
                        {renderThumbnail()}
                        {renderNumbers()}
                    </Stack>
                    <Stack direction="row" alignItems="center" gap={1} justifyContent="end">
                        <Divider orientation="vertical" flexItem />
                        {renderErpInformationAndQuantity()}
                    </Stack>
                </Stack>
            </Container>
        </Collapse>
    )
}
